import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faTableColumns } from '@fortawesome/pro-regular-svg-icons/faTableColumns';
import { useState } from 'react';
import { AlignRight } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Menu } from '../../../navigation/Menu/Menu.js';
import { Button } from '../../../navigation/buttons/Button/Button.js';
import { Typography } from '../../../foundation/Typography/styled.js';
import { MenuList, MenuItem } from '../../../navigation/Menu/styled.js';
import { Switch } from '../../../../toggles/components/Switch/index.js';

function TableColumnToggle(props) {
  var _jsx2;
  var children = props.children,
    headers = props.headers,
    onChange = props.onChange,
    size = props.size;
  var headerOptions = headers.map(function (header) {
    var _a;
    return Object.assign(Object.assign({}, header), {
      active: (_a = header.active) !== null && _a !== void 0 ? _a : true
    });
  });
  var _useState = useState(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(headerOptions),
    colRows = _useState2[0],
    setColRows = _useState2[1];
  var handleClick = function handleClick() {
    setOpen(!isOpen);
  };
  var handleChange = function handleChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      checked = _event$target.checked;
    var newState = colRows.map(function (col) {
      if (col.id === name) {
        return Object.assign(Object.assign({}, col), {
          active: checked
        });
      }
      return col;
    });
    setColRows(newState);
    onChange(newState);
  };
  return /*#__PURE__*/jsx(Menu, {
    open: isOpen,
    onClose: function onClose() {
      return setOpen(false);
    },
    target: /*#__PURE__*/jsxs(Button, {
      onClick: handleClick,
      appearance: "ghost",
      size: size,
      children: [/*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
        icon: "table-columns"
      }, _jsx2["icon"] = faTableColumns, _jsx2)), /*#__PURE__*/jsx(Typography, {
        children: children
      })]
    }),
    children: /*#__PURE__*/jsx(MenuList, {
      children: colRows.map(function (_ref) {
        var id = _ref.id,
          label = _ref.label,
          disabled = _ref.disabled,
          active = _ref.active;
        return /*#__PURE__*/jsxs(MenuItem, {
          as: "label",
          id: id,
          disabled: disabled,
          children: [label || id, /*#__PURE__*/jsx(AlignRight, {
            children: /*#__PURE__*/jsx(Switch, {
              disabled: disabled,
              checked: active,
              name: id,
              onChange: handleChange
            })
          })]
        }, id);
      })
    })
  });
}

export { TableColumnToggle };
